import { render, staticRenderFns } from "./shopInfoCell.vue?vue&type=template&id=5b209a03"
import script from "./shopInfoCell.vue?vue&type=script&lang=js"
export * from "./shopInfoCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports